import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch, ref } from "vue";
  import CheckMark from "@/components/ui/icons/Checkmark.vue";
  import {
    CustomizeHouseStepsEnum,
    CustomizeHouseStepsReviewQuoteEnum,
  } from "@/enums/CustomizeHouseSteps";
  import { StepTypeEnum } from "@/enums/BuilderStepType";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Stepper',
  props: {
    step: {
      type: String,
      default: "",
    },
    tabs: {
      type: Array,
      default: () => [],
    },
    stepType: {
      type: String,
      default: StepTypeEnum.CUSTOMIZE_HOUSE_STEPS,
      required: false,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const steppyProgress = computed(() => {
    return `${(100 / (props.tabs.length - 1)) * (stepIndex.value - 1)}%`;
  });

  const stepIndex = computed(() => {
    const enumToUse =
      props.stepType === StepTypeEnum.CUSTOMIZE_HOUSE_STEPS_REVIEW_QUOTE
        ? CustomizeHouseStepsReviewQuoteEnum
        : CustomizeHouseStepsEnum;

    return (
      Object.values(enumToUse).findIndex((item) => item === props.step) + 1
    );
  });

const __returned__ = { props, steppyProgress, stepIndex, computed, reactive, watch, ref, CheckMark, get CustomizeHouseStepsEnum() { return CustomizeHouseStepsEnum }, get CustomizeHouseStepsReviewQuoteEnum() { return CustomizeHouseStepsReviewQuoteEnum }, get StepTypeEnum() { return StepTypeEnum } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})